// extracted by mini-css-extract-plugin
export default {"logoAnimationContainer":"LogoAnimation_logoAnimationContainer__veo-D","logo":"LogoAnimation_logo__yaBun"};